/*
 * dayjs locale for CMMS date pickers.
 *
 * cmmsFormat.js owns how CMMS *prints* a date; this owns how CMMS *picks* one. Kept separate
 * rather than folded into cmmsFormat.js so the two dayjs locale bundles are not pulled into
 * every grid that imports a formatter.
 *
 * MUI's x-date-pickers v5 builds the adapter in a useMemo keyed on adapterLocale, so a
 * language change re-creates it and the picker re-renders without a page load. The dayjs
 * imports on this module register the locales globally; nothing in the app calls
 * dayjs.locale(), so they stay dormant until a picker asks for one.
 *
 * Why the fallback is en and not the browser locale: cmmsFormat.js' en output is documented as
 * 08/03/2026 (US format), and IntlProvider's default is redux's default — en. Giving the
 * picker a different locale than the grid beside it would make them disagree, and the grid is
 * the one that gets read.
 *
 * Adding a locale means adding both the import and the set entry. Missing one fails silently —
 * the adapter runs in en — which is exactly the bug this was created to fix.
 */

import "dayjs/locale/en";
import "dayjs/locale/sv";

const REGISTERED_LOCALES = new Set(["en", "sv"]);

export const toDayjsLocale = (locale) => {
  if (!locale || typeof locale !== "string") return "en";
  const base = locale.toLowerCase().split("-")[0];
  return REGISTERED_LOCALES.has(base) ? base : "en";
};